module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// Activity_Event_BlogPostEvent Widget

(function (fox, $) {
	
	fox.registerWidget('Activity_Event_CustomEvent', {

		configure: function () {
			this.fullEventDescriptionAvailable = false;

			this.registerOptions('', {
				autoRender: true,
				template: 'activity_event_card_customevent',
				'widgets.fullDescription': {
					widget: 'Widget',
					template: 'activity_event_card_customevent_description',
					autoRender: false,
					embed: {
						widget: '@parent @parent',
						container: '.full-description-wrapper'
					},
					'hooks.onAddedToDom': fox.bind(function () {
						this.applyScrollBar();
					}, this)
				},
				'handleDom.showFullText': {
					target: '.show-more-text',
					event: 'click',
					callback: '_showFullText'
				},
				'handleDom.hideFullText': {
					target: '.close',
					targetWidget: '#fullDescription',
					event: 'click',
					callback: 'hideFullText'
				},
				'!hooks.onStartRendering': function () {
					var props = this.p.getMainProperties();

					if (fox.isString(props.eventDescription)) {
						if (props.eventDescription.length > 101) {
							props.fullEventDescriptionAvailable = true;
							this.fullEventDescriptionAvailable = true;
						}
					};
					
					this.setTemplateOptions(props);

					if (props.fullEventDescriptionAvailable) {
						this.wom1('#fullDescription').setTemplateOptions(props).render();
					}

					return true;
				},
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.p = this.getParent();
		
			this.callParent('init', arguments);
		},

		_showFullText: function (argument) {
			if (this.fullEventDescriptionAvailable) {
				this.showFullText();
			}
		},

		showFullText: function () {
			fox.dom.addClass('show-full-description', this.getParent().element[0]);
		},

		hideFullText: function () {
			fox.dom.removeClass('show-full-description', this.getParent().element[0]);
		},

		applyScrollBar: function () {
			$(this.rwom1('#fullDescription').element[0])
				.find('.event-description.full')
				.mCustomScrollbar({
					theme: 'light-thin',
					scrollButtons: false,
					scrollbarPosition: 'inside',
					scrollInertia: 0,
					mouseWheel: {preventDefault: true}
				});
		}
	}, 'Widget');

})(fox, jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/activity/event/customEvent.js
// module id = 816
// module chunks = 4